import { render, staticRenderFns } from "./Profile-Status.vue?vue&type=template&id=7156c331&scoped=true&"
import script from "./Profile-Status.vue?vue&type=script&lang=js&"
export * from "./Profile-Status.vue?vue&type=script&lang=js&"
import style0 from "./Profile-Status.vue?vue&type=style&index=0&id=7156c331&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7156c331",
  null
  
)

export default component.exports